import { createClient } from '@supabase/supabase-js';

// Get Supabase URL and anon key from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validate environment variables
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('[Supabase] Missing environment variables:', {
    url: !!supabaseUrl,
    key: !!supabaseAnonKey
  });
  throw new Error('Supabase configuration is missing. Check your .env file.');
}

// Create Supabase client with explicit session persistence
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Explicitly enable session persistence to localStorage
    persistSession: true,

    // Use browser localStorage for session storage
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,

    // Storage key pattern: sb-{project-id}-auth-token
    storageKey: `sb-${supabaseUrl.split('//')[1].split('.')[0]}-auth-token`,

    // Auto-refresh the session before it expires
    autoRefreshToken: true,

    // Enable automatic URL detection for OAuth callback
    // This allows Supabase to automatically handle code exchange
    detectSessionInUrl: true,

    // Flow type for OAuth
    flowType: 'pkce',

    // Add debug mode in development
    debug: process.env.NODE_ENV === 'development'
  },

  // Global options
  global: {
    headers: {
      'X-Client-Info': 'kausora-kis-frontend'
    }
  }
});

console.log('[Supabase] Client initialized successfully');

// Add request interceptor for debugging (development only)
if (process.env.NODE_ENV === 'development') {
  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    const [url] = args;
    if (typeof url === 'string' && url.includes('supabase.co')) {
      console.log('[Supabase] Request:', url);
    }
    try {
      const response = await originalFetch(...args);
      if (typeof url === 'string' && url.includes('supabase.co')) {
        console.log('[Supabase] Response:', response.status, url);
      }
      return response;
    } catch (error) {
      if (typeof url === 'string' && url.includes('supabase.co')) {
        console.error('[Supabase] Request failed:', url, error);
      }
      throw error;
    }
  };
}

export default supabase;
